import { debounce } from '@cian/ui-kit/internal/utils';
import { ECalculatorEventName, dispatchWidgetEvent } from '../../common/utils';
import { ECustomEventsDescriptions } from '../constants/customEventsDescriptions';

export const debouncedClickMoreFiltersAnalyticsHandler = (eventTarget: HTMLButtonElement | null) =>
  debounce(() => {
    if (eventTarget) {
      dispatchWidgetEvent(eventTarget, ECalculatorEventName.onSendAnalytics, {
        description: ECustomEventsDescriptions.onAnalytics,
        data: { eventName: 'onClickMoreFilters' },
      });
    }
  }, 500);
